var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{key:_vm.name,staticClass:"common-verify"},[(_vm.verificationType === "1"||_vm.verificationType === "2")?_c('AliyunCaptcha',{attrs:{"width":_vm.width,"marginTop":_vm.marginTop,"errorHave":_vm.errorHave,"errorText":_vm.errorText,"errorFlag":_vm.errorFlag},on:{"callback":_vm.callback}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }